module.exports = __webpack_public_path__ + "img/logo.af1a05b4.svg";